import interact from 'interact.js'
import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({ selector: '[allowDrop]' })
export class AllowDropDirective implements OnInit {
    @Input() allowDrop:boolean;

    ngOnInit() {
        if (this.allowDrop) interact(this.el.nativeElement).dropzone({
            accept: 'book'
        });
    }

    constructor(private el: ElementRef) {
        el.nativeElement.isDropAllowed = () => {
            return this.allowDrop;
        }
    }
}


// WEBPACK FOOTER //
// ./web/static/components/book/directives/AllowDrop.ts